import React from 'react'
import { SvgIcon } from '@mui/material'

// TODO: STROKE DOESN'T ACCEPT A VARIABLE
export const SharedMediaIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M20.5 4v-.5h-13v13h13V4Zm-6.92 10.24 2.09-2.6 2.3 2.86h-4.6l.21-.26Zm-.79-.01.2.27H10l1.5-2 1.29 1.73ZM3.5 20v.5h14v1H4A1.5 1.5 0 0 1 2.5 20V6.5h1V20ZM8 2.5h12c.82 0 1.5.68 1.5 1.5v12c0 .82-.68 1.5-1.5 1.5H8A1.5 1.5 0 0 1 6.5 16V4c0-.82.68-1.5 1.5-1.5Z"
      fill="inherit"
      stroke="inherit" // SECONDARY.MAIN
    />
  </SvgIcon>
)
